import { motion } from "framer-motion";

const POINTS = [
  "100% genuine parts with photo proof",
  "Transparent estimates before work begins",
  "Live photo/video updates of your car",
  "Trained technicians for all brands",
  "Old parts returned to you",
];

export default function WhyAutoHQ() {
  return (
    <section className="py-16 sm:py-28 px-5 lg:px-8 bg-white" data-testid="why-section">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs uppercase tracking-[0.25em] text-[#FF5A00] font-bold mb-3">Why AutoHQ</p>
        <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-[#0A0A0A]">
          Built on <span className="text-[#FF5A00]">Trust</span>, Not Discounts.
        </h2>
        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {POINTS.map((p, i) => (
            <motion.div
              key={p}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.07 }}
              className="bg-[#FAFAFA] border border-[#E4E4E7] rounded-sm p-6 hover:border-[#FF5A00] transition-colors"
            >
              <span className="text-2xl font-extrabold text-[#FF5A00]/60">{String(i + 1).padStart(2, "0")}</span>
              <p className="mt-3 text-sm font-semibold leading-snug text-[#0A0A0A]">{p}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
